import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomViewsUpgradeLink = ({
  openUpgradeModal
}) => /*#__PURE__*/_jsxs(UIButton, {
  onClick: openUpgradeModal,
  "data-test-id": "upgrade-point-custom-view",
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.viewsSidebar.actions.createCustomView"
  }), /*#__PURE__*/_jsx(UILockBadge, {})]
});
CustomViewsUpgradeLink.displayName = 'CustomViewsUpgradeLink';
export default CustomViewsUpgradeLink;